import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { setPassword as passwordAction, setMailPasswordError } from '../store/signup/signupAction';

/**
 * Password form
 * @param {*} param0
 */
const PasswordForm = ({ passwordAction, mailPasswordError, setMailPasswordError }) => {
    const [password, savePassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errPassword, setErrPassword] = useState(false);
    const [errPswdMsg, setErrPswdMsg] = useState('');
    const [errConfPassword, setErrConPassword] = useState(false);
    const [errConfPswdMsg, setConfErrPswdMsg] = useState('');
    const [touched, setTouched] = useState(false);
    const [confTouched, setConfTouched] = useState(false);

    useEffect(() => {
        if (!errPassword && !errConfPassword && confirmPassword !== '') {
            passwordAction(password);
        } else {
            passwordAction('');
        }
    }, [passwordAction, errPassword, errConfPassword, password, confirmPassword]);

    useEffect(() => {
        if (mailPasswordError && (password === '' || confirmPassword === '')) {
            if (password === '') {
                setErrPassword(true);
                setErrPswdMsg('Required');
            }
            if (confirmPassword === '') {
                setErrConPassword(true);
                setConfErrPswdMsg('Required');
            }
        }
        if (touched) {
            if (
                !/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,30}/.test(
                    password
                )
            ) {
                setErrPassword(true);
                setErrPswdMsg(password === '' ? "Required" :
                    'Password must have atleast 1 special character , 1 number and should be 8 characters long'
                );
            } else if (password === confirmPassword) {
                passwordAction(password);
                setErrPassword(false);
                setErrPswdMsg(null);
            } else {
                setErrPassword(false);
                setErrPswdMsg(null);
            }
        }
        if (confTouched) {
            if (confirmPassword === '') {
                setErrConPassword(true);
                setConfErrPswdMsg("Required");
            } else if (password === confirmPassword) {
                passwordAction(password);
                setErrConPassword(false);
                setConfErrPswdMsg(null);
            } else if (password !== confirmPassword) {
                setErrConPassword(true);
                setConfErrPswdMsg('Passwords do not match');
            } else {
                setErrConPassword(false);
                setConfErrPswdMsg(null);
            }
        }
    }, [
        password,
        confirmPassword,
        setErrPassword,
        setErrPswdMsg,
        setErrConPassword,
        setConfErrPswdMsg,
        passwordAction, confTouched,
        touched, mailPasswordError
    ]);
    return (
        <form>
            <div className="form-block">
                <div className="row email-pass-reset">
                    <div className="form-group col-2">
                        <input
                            name="password"
                            placeholder="Password"
                            type="password"
                            className={`form-control ${errPassword ? 'inf-error' : ''
                                }`}
                            value={password}
                            onChange={(e) => {
                                savePassword(e.target.value);
                                setMailPasswordError(false);
                            }}
                            onBlur={() => setTouched(true)}
                        />
                        {errPswdMsg && (
                            <span className="input-error-password">{errPswdMsg}</span>
                        )}
                    </div>
                    <div className="form-group col-2">
                        <input
                            placeholder="Re Enter Password"
                            name="confirm password"
                            type="password"
                            className={`form-control ${errConfPassword ? 'inf-error' : ''
                                }`}
                            value={confirmPassword}
                            onBlur={() => setConfTouched(true)}
                            onChange={(e) => {
                                setConfirmPassword(e.target.value);
                                setConfTouched(true);
                                setMailPasswordError(false);
                            }}
                        />
                        {errConfPswdMsg && (
                            <span className="input-error-password">{errConfPswdMsg}</span>
                        )}
                    </div>

                </div>
            </div>
        </form>
    );
};

const mapStateToProps = (store) => ({
    mailPasswordError: get(
        store,
        'signupReducer.mailPasswordError',
        false
    ),
});
const mapDispatchToProps = { passwordAction, setMailPasswordError };

export default connect(mapStateToProps, mapDispatchToProps)(PasswordForm);
